import { render, staticRenderFns } from "./productInspection.vue?vue&type=template&id=6a08fe21&scoped=true"
import script from "./productInspection.vue?vue&type=script&lang=js"
export * from "./productInspection.vue?vue&type=script&lang=js"
import style0 from "./productInspection.vue?vue&type=style&index=0&id=6a08fe21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08fe21",
  null
  
)

export default component.exports